module.exports = __webpack_public_path__ + "img/seedback-color.7892ba8a.svg";